import { MutationTree } from 'vuex';
import { Template } from '@/types';

export interface BackgroundsState {
  backgrounds: Template[];
}

export const namespaced = true;

export const state = (): BackgroundsState => ({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  backgrounds: (window as any).$store.backgrounds,
});

export const mutations: MutationTree<BackgroundsState> = {};
